<template lang="pug">
	.contieneBloques(
		tabindex="4"
		@keydown="teclaAbajo"
		@keyup="teclaArriba"
	)
		div.contieneTabla(style="flex-grow: 1;")
			table.table.table-striped
				thead.bg-dark.text-white
					tr
						th.p-1 Nombre bloque
						th.p-1 Hora de inicio
						th.p-1 Hora de fin
						th.p-1 Duración
						th.p-1 Programado
				tbody
					tr(
						v-for="(blo, index) in bloques",
						:key="blo.BloqueID"
						@click="seleccionaBloque(blo)"
						style="cursor: default;"
						:class="(bloqueActivo && bloqueActivo.BloqueID === blo.BloqueID) ? 'bg-info text-white' : ''"
						:id="'bloque-' + blo.BloqueID"
					)
						td.p-1
							| {{blo.BloqueDescripcion}}
							span.text-danger.fa.fa-podcast.ml-2(v-if="blo.insercionesEncontradas")
						td.p-1 {{blo.BloqueHoraInicio}}
						td.p-1 {{blo.BloqueHoraFin}}
						td.p-1(:class="(porcentajeBloque(blo) >= 110) ? 'bg-dark text-white' : (porcentajeBloque(blo) >= 100) ? 'bg-danger text-white' : (porcentajeBloque(blo) > 75) ? 'bg-warning' : (porcentajeBloque(blo) >= 15) ? 'bg-success text-white' : ''")
							span {{blo.duracion | moment('mm:ss')}}
						td.p-1(:class="(porcentajeBloque(blo) >= 110) ? 'bg-dark text-white' : (porcentajeBloque(blo) >= 100) ? 'bg-danger text-white' : (porcentajeBloque(blo) > 75) ? 'bg-warning' : (porcentajeBloque(blo) >= 15) ? 'bg-success text-white' : ''")
							span {{_getTiempo(blo.DuracionObjetosFisica, true)}} ({{porcentajeBloque(blo)}} %)
		div.p-1.text-right.bg-warning(v-if="bloqueActivo", style="font-size:1.4em;flex-basis: 0;height:auto;")
			.row
				.col.text-center
					b Bloque:
					|  {{bloqueActivo.BloqueHoraInicio}} - {{bloqueActivo.BloqueHoraFin}}
				.col.text-center(:class="(sobreOcupacionParrilla) ? 'text-danger font-weight-bold' : ''")
					| Quedan: {{ tiempoRestanteParrilla }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data () {
		return {
			indice: null,
			teclas: {
				ctrl: false,
				shift: false
			}
		}
	},
	computed: {
		...mapGetters({
			bloqueActivo: 'organizar-emisoras/bloqueActivo',
			bloques: 'organizar-emisoras/listadoBloques'
		}),
		tiempoRestanteParrilla () {
			if (!this.bloqueActivo) {
				return this._getTiempo(0)
			} else {
				return this._getTiempo(this.bloqueActivo.duracion - this.bloqueActivo.DuracionObjetosFisica, true)
			}
		},
		sobreOcupacionParrilla () {
			if (!this.bloqueActivo) {
				return 0
			}
			return (this.bloqueActivo.duracion - this.bloqueActivo.DuracionObjetosFisica < 0)
		}
	},
	methods: {
		...mapActions({
			seleccionaBloque: 'organizar-emisoras/seleccionaBloque'
		}),
		teclaAbajo (e) {
			if (e.keyCode !== 9) {
				e.preventDefault()
				e.stopPropagation()
			}
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey

			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(1)
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(-1)
			}
		},
		teclaArriba (e) {
			if (e.keyCode !== 9) {
				e.preventDefault()
				e.stopPropagation()
			}
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey
		},
		seleccionaIndice (pos) {
			if (this.bloques.length === 0) {
				return
			}
			const i = this.bloques.indexOf(this.bloqueActivo)
			if (i + pos >= this.bloques.length) {
				// Seleccionamos el primero
				this.seleccionaBloque(this.bloques[0])
			} else if (i + pos < 0) {
				// Seleccionamos el último
				this.seleccionaBloque(this.bloques[this.bloques.length - 1])
			} else {
				this.seleccionaBloque(this.bloques[i + pos])
			}
			if (this.bloqueActivo) {
				window.setTimeout(() => {
					const el = document.getElementById('bloque-' + this.bloqueActivo.BloqueID)
					if (el) {
						el.scrollIntoView({block: 'end', behavior: 'instant'})
					}
				}, 100)
			}
		},

		porcentajeBloque (bloque) {
			return Math.round(bloque.DuracionObjetosFisica * 100 / bloque.duracion)
		},

		// PRIVADOS
		_getTiempo (valor, decimales) {
			valor = Math.round(valor * 100) / 100
			let neg = (valor < 0)
			valor = (valor < 0) ? valor * -1 : valor
			let h = '00'
			let m = '00'
			let s = '00'
			let decimas = '0'
			decimas = (valor.toString().match(/\./)) ? valor.toString().split('.')[1] : '0'

			if (valor >= 3600) {
				h = Math.floor(valor / 3600)
				h = (h < 10) ? '0' + h : h
				valor = valor % 3600
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60)
				m = (m < 10) ? '0' + m : m
				valor = valor % 60
			}

			s = parseInt(valor)
			s = (s < 10) ? '0' + s : s

			decimas = decimas.toString()
			while (decimas.length < 1) {
				decimas = decimas + '0'
			}

			const menos = (neg) ? '-' : ''

			return (!decimales) ? menos + '' + h + ':' + m + ':' + s : menos + '' + h + ':' + m + ':' + s + '.' + decimas
		}
	}
}
</script>

<style scoped>
	.contieneBloques {
		display: flex;
		position: relative;
		flex-direction: column;
		align-content: stretch;
		align-items: stretch;
		align-self: stretch;
		flex-shrink: 1;
		flex-basis: 0;
	}
	.contieneBloques > .contieneTabla {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: 0;
		overflow-y: auto;
		background-color: white;
		margin-bottom: 2px;
		border: 1px solid #e0e0e0;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/bloques.vue